import React from "react"
import { useToasts } from "react-toast-notifications"
import AddRemoveButton from "../../../ui/molecules/AddRemoveButton"
import { useLabels } from "../../contents/hooks"

export interface Props {
  quantity: number
  onQuantityChange: (value: number) => void
  maxQuantity: number
  iconSize?: number
}

const MAX_WEBSITE_SELL_QUANTITY = 5

const normalizeMaxQuantity = (value: number) => {
  if (value === 0) {
    return 1
  }
  if (value > MAX_WEBSITE_SELL_QUANTITY) {
    return MAX_WEBSITE_SELL_QUANTITY
  }
  return value
}

const ProductQuantityChange = ({
  quantity,
  maxQuantity,
  onQuantityChange,
  iconSize,
}: Props) => {
  const { addToast } = useToasts()
  const { getLabel } = useLabels()

  const handleQuantityChange = (newQuantity: number) => {
    if (newQuantity === MAX_WEBSITE_SELL_QUANTITY) {
      addToast(getLabel("product", "max-sell-quantity"), {
        autoDismiss: true,
        appearance: "warning",
      })
    }
    onQuantityChange(newQuantity)
  }

  return (
    <AddRemoveButton
      value={quantity}
      min={1}
      max={normalizeMaxQuantity(maxQuantity)}
      onChange={handleQuantityChange}
      variant="outlinedBottom"
      iconSize={iconSize}
    />
  )
}

export default ProductQuantityChange
